function alternateSkus() {
  const skus = document.querySelectorAll('.alternate-skus')

  if (skus) {
    for (let i = 0; i < skus.length; i += 1) {
      const selectedSkus = skus[i].querySelectorAll('h6')
      if (selectedSkus) {
        for (let j = 0; j < selectedSkus.length; j += 1) {
          if (selectedSkus[j]) {
            const html = selectedSkus[j].innerHTML
            const replacedText = html.replace(/([^,]+)/g, '<span>$1</span>')
            selectedSkus[j].innerHTML = replacedText
          }
        }
      }
    }
  }
}

alternateSkus()
